export default __webpack_public_path__ + "heart-fill.svg";